(function () {
    'use strict';

    a3_cabin_reports.factory('ASSFSyncInfoFactory', ASSFSyncInfoFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ASSFSyncInfoFactory
    * @description 
    * Add, Update and Get SaFeedbacks Info
    * @ngInject
    */
    function ASSFSyncInfoFactory(GenericService, defaultCalendarDate) {

        var objType = 'ASSFSyncInfo';
        var objCallback = ASSFSyncInfo;

        /**
         * Initialize the ASSFSyncInfo
         * @memberof ASSFSyncInfoFactory
         */
        function ASSFSyncInfo() {
            this.ActiveVersion = {};
            this.ApplicabilityRules = [];
            this.SyncedFlightIds = [];
        }

        var service = {
            setASSFInfo: setASSFInfo,
            getASSFInfo:getASSFInfo,
            //checkIsRequired: checkIsRequired

        };

        function setASSFInfo(syncInfo) {
            if (syncInfo != null && syncInfo.ActiveVersion && syncInfo.ApplicabilityRules) {

                var assfInfo = { 
                    ActiveVersion: syncInfo.ActiveVersion, 
                    ApplicabilityRules: syncInfo.ApplicabilityRules,
                    SyncedFlightIds: syncInfo.SyncedFlightIds
                }; 
                GenericService.saveOne(assfInfo, objType, objCallback);
            }
        }

        /**
         * Get assf Info from local storage
         */
        function getASSFInfo() {
            return GenericService.getOne(objType, objCallback);
        }


        //Object services
        /**
         * Overide default get Id
         * @memberof ASSFSyncInfoFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

       
        return service;
    }

})();